"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireWildcard(require("react"));
require("./TaskMultiChoice.scss");
var _DesignComponents = require("../DesignComponents/DesignComponents");
var _ModalFeedback = _interopRequireDefault(require("../ModalFeedback/ModalFeedback"));
var _AlertFeedback = _interopRequireDefault(require("../AlertFeedback/AlertFeedback"));
var _CompletedContext = require("../CompletedContext");
var _reactUseIdHook = require("react-use-id-hook");
var _util = require("../util");
function IdRadioGroup(props) {
  var id = (0, _reactUseIdHook.useId)();
  var name = props.id || "rg-".concat(id);
  return /*#__PURE__*/_react.default.createElement(_DesignComponents.RadioGroup, Object.assign({}, props, {
    id: name,
    name: name
  }), props.children);
}
function IdRadio(props) {
  var id = (0, _reactUseIdHook.useId)();
  return /*#__PURE__*/_react.default.createElement(_DesignComponents.Radio, Object.assign({}, props, {
    id: "radio-".concat(id)
  }), props.children);
}
var TaskMultiChoice = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TaskMultiChoice, _Component);
  var _super = (0, _createSuper2.default)(TaskMultiChoice);
  function TaskMultiChoice(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TaskMultiChoice);
    _this = _super.call(this, props);
    _this.handleSubmit = function (e) {
      var _this$props;
      e.preventDefault();
      var finished = false;
      if ((_this$props = _this.props) !== null && _this$props !== void 0 && _this$props.maxAttempts) {
        var temp = _this.state.attempts;
        temp++;
        _this.setState({
          attempts: temp
        });
        if (temp >= _this.props.maxAttempts) {
          finished = true;
        }
      }
      _this.setState({
        showFeedback: true,
        completed: finished || _this.isCorrect()
      });
    };
    _this.state = props.state || {};
    if (!_this.state.initialized) {
      _this.state.initialized = true;
      // Initial state is set here, since the constructor can be called more than once.
      _this.state.completed = false;
      _this.state.selected = null;
      _this.state.showFeedback = false;
      _this.state.indexMap = [];
      _this.state.attempts = 0;
      for (var i = 0; i < _this.props.choices.length; i++) {
        _this.state.indexMap[i] = i;
      }
      if (_this.props.randomize) {
        (0, _util.shuffle)(_this.state.indexMap);
      }
    }
    return _this;
  }
  (0, _createClass2.default)(TaskMultiChoice, [{
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "isCorrect",
    value: function isCorrect() {
      if (typeof this.props.correct === "object" && this.props.correct.includes) {
        return this.props.correct.includes(this.state.indexMap[this.state.selected]);
      }
      return this.props.correct === this.state.indexMap[this.state.selected];
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.correct !== this.state.correct || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }
      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
      if (prevprops.choices !== this.props.choices) {
        for (var i = 0; i < this.props.choices.length; i++) {
          this.state.indexMap[i] = i;
        }
        if (this.props.randomize) {
          (0, _util.shuffle)(this.state.indexMap);
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2,
        _this$props3,
        _this3 = this;
      if (this.props.prompt === undefined) {
        throw new Error("TaskMultiChoice: prop `prompt` is required for accessibility.");
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: this.props.ref,
        key: this.props.key,
        className: "task task-multi-choice" + (((_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.cols) > 1 ? " task-multi-choice-no-new-line" : ""),
        style: (0, _objectSpread2.default)({
          "--taskmultichoice-cols": this.props.cols,
          "--nds-field-group-justify-content": ((_this$props3 = this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.justifyChoices) || "left"
        }, this.props.style)
      }, /*#__PURE__*/_react.default.createElement("form", {
        id: this.props.id
      }, /*#__PURE__*/_react.default.createElement(IdRadioGroup, {
        label: this.props.prompt
      }, this.props.choices.map(function (v, k) {
        if (v === undefined || k === undefined) {
          console.log("UNDEF: ", _this3.props.data, "INDEX: ", k);
        }
        //console.log("TaskMultiChoice v", v)
        //console.log("PROPS:", this.props.showAnswer, this.state.indexMap[k], this.props.correct)
        v = [_this3.props.showAnswer && _this3.props.correct.indexOf(_this3.state.indexMap[k]) !== -1 ? "Correct: " : "", _this3.props.choices[_this3.state.indexMap[k]]];
        //console.log("TaskMultiChoice v2", v)
        return /*#__PURE__*/_react.default.createElement(IdRadio, {
          key: _this3.state.indexMap[k],
          onChange: function onChange() {
            _this3.setState({
              selected: k,
              showFeedback: false
            });
          },
          disabled: _this3.state.completed,
          checked: k === _this3.state.selected,
          value: k
        }, v);
      })), !this.state.completed && /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
        className: "bdg-submit-button",
        style: {
          marginLeft: 'auto',
          display: 'block'
        },
        type: "submit",
        onClick: this.handleSubmit
      }, "Submit")), /*#__PURE__*/_react.default.createElement(_ModalFeedback.default, {
        noRetry: this.state.completed,
        correct: this.props.neutralFeedback ? undefined : this.isCorrect(),
        show: this.state.showFeedback,
        onHide: function onHide() {
          _this3.setState({
            showFeedback: false
          });
        }
      }, this.props.feedback[this.state.indexMap[this.state.selected]] || "Please select an option."));
    }
  }]);
  return TaskMultiChoice;
}(_react.Component);
exports.default = TaskMultiChoice;
TaskMultiChoice.contextType = _CompletedContext.CompletedContext;